export default {
  payment: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  stockOption: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  kitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  statusKitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  statusKitClients: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  vinculoKitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  documentsKitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  tipoKitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  professionalKitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  clientKitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  opcoesKitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  conjuntoKitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  pjKitPartners: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // {{NEXT}}
}
